import TopAbout from 'assets/images/about/top_about.png';
import KeyVisual from 'assets/images/about/key_visual.png'
import styles from "styles/About.module.css"

const About: React.FC = () => {
  return (
    <div className={styles["split-container"]} id="about">
      <div className={styles["key-visual-container"]}>
        <img
          src={KeyVisual}
          className={styles["key-visual"]}
          alt="キービジュアル"
        />
      </div>
      <div className={styles["right-container"]}>
        <img src={TopAbout} className={styles["top-about-logo"]} alt="About"/>
        <div className={styles["catch-copy-1"]}>
          <h3><span>シンプルなルールだからこそ奥深い</span></h3>
          <h3><span>１つのルールの頂点を巡る戦いがここにはある</span></h3>
        </div>
        <div className={styles["catch-copy-2"]}>
          <p>コミュニティ有数の歴史をもつガチエリア限定大会を筆頭に</p>
          <p>ハイレベルな大会をハイクオリティに手掛ける</p>
          <p>進化と変化を続けて行くコミュニティ大会のパイオニア！</p>
        </div>
      </div>
    </div>
  );
};

export default About;
